//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        value: {
            type: Boolean,
            required: true
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 500
        },
        height: {
            type: Number,
            default: 60
        }
    },

    data () {
        return {
            show: false,
            input: this.value
        };
    },

    watch: {
        input () {
            this.$emit('input', this.input);
        },
        value () {
            this.input = this.value;
        }
    },

    mounted () {
        this.PIXIWrapper.LoaderManager.add(this, () => {
            this.show = true;
        });
    }
};
